import VerifyPasswordAuth from "modules/auth/VerifyPassword";

const VerifyPassword = () => {
  return <VerifyPasswordAuth />
};

export default VerifyPassword;